"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var UsersOutline_1 = __importDefault(require("../icons/generated/UsersOutline"));
var button_component_1 = __importDefault(require("../inputs/button.component"));
var CenteredContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n  background: ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  box-sizing: border-box;\n  background: ", ";\n  color: ", ";\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.app.background;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.app.color;
});
CenteredContainer.displayName = 'CenteredContainer';
var IconWrapper = styled_components_1.default.figure(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 64px;\n  margin: 0;\n\n  @media (min-width: ", ") {\n    height: 96px;\n  }\n\n  svg {\n    height: 100%;\n    fill: ", ";\n  }\n"], ["\n  height: 64px;\n  margin: 0;\n\n  @media (min-width: ", ") {\n    height: 96px;\n  }\n\n  svg {\n    height: 100%;\n    fill: ", ";\n  }\n"])), function (_a) {
    var breakpoints = _a.theme.breakpoints;
    return breakpoints.md;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.app.color;
});
var Message = styled_components_1.default.h1(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 24px;\n  line-height: 1.2;\n  margin: 20px 0;\n\n  @media (min-width: ", ") {\n    font-size: 32px;\n  }\n"], ["\n  font-size: 24px;\n  line-height: 1.2;\n  margin: 20px 0;\n\n  @media (min-width: ", ") {\n    font-size: 32px;\n  }\n"])), function (_a) {
    var breakpoints = _a.theme.breakpoints;
    return breakpoints.md;
});
Message.displayName = 'Message';
var SecondaryMessage = styled_components_1.default.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 300px;\n  margin: 0;\n  line-height: 20px;\n  color: ", ";\n"], ["\n  max-width: 300px;\n  margin: 0;\n  line-height: 20px;\n  color: ", ";\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.app.fadedColor;
});
SecondaryMessage.displayName = 'SecondaryMessage';
var Spacer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 32px;\n"], ["\n  margin-bottom: 32px;\n"])));
var EmptyState = function (_a) {
    var icon = _a.icon, primaryText = _a.primaryText, secondaryText = _a.secondaryText, buttonProps = _a.buttonProps;
    var usedIcon = icon ? icon : react_1.default.createElement(UsersOutline_1.default, null);
    return (react_1.default.createElement(CenteredContainer, null,
        react_1.default.createElement(IconWrapper, null, usedIcon),
        react_1.default.createElement(Message, null, primaryText),
        react_1.default.createElement(SecondaryMessage, null, secondaryText),
        buttonProps ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Spacer, null),
            react_1.default.createElement(button_component_1.default, __assign({}, buttonProps), buttonProps.children))) : null));
};
EmptyState.displayName = 'EmptyState';
exports.default = EmptyState;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
